<template>
  <div class="telemetria" style="background-color:#ffffff; border-radius: 20px;">

    <vue-element-loading :active="cargando" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..."/>
    <div class="form-row">
      <h1 class="col-8">Reporte de Telemetrias</h1>
      <div class="col-3"></div>
      <router-link to="/home">
        <b-button variant="outline-success" style="margin: 10px">
          <div class="h6 mb-1">
            <b-icon-arrow-left-square></b-icon-arrow-left-square>
          </div>
          <div style="font-size: 12px;">
            Inicio
          </div>
        </b-button>
      </router-link>
    </div>

    <div class="row">
      <div class="col-12">
        <label class="col-form-label">Unidades</label>
        <multiselect ref="select" v-model="dispositivosSeleccionados" placeholder="Seleccione los dispositivos" label="name" track-by="id" :options="dispositivosObtenidos" :multiple="true" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover"
        >
        </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAll">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAll">Limpiar</button>
      </div>
      <div class="col-12">
        <label class="col-form-label">Grupos</label>
        <multiselect ref="select" v-model="gruposSeleccionados" placeholder="Seleccione los dispositivos" label="name" track-by="id" :options="gruposObtenidos" :multiple="true" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover">
        </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAllGrupos">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAllGrupos">Limpiar</button>
      </div>
      <div class="col-12">
        <label class="col-form-label">Eventos</label>
       <select name="selectEventos" type="text" class="form-control" v-model="eventos">
         <option selected value="deviceOverspeed">Telemetria Basica</option>
         
         <option value="Complete">Telemetria Completa</option>   
         <option value="Velocity">Telemetria Exceso Velocidad</option>                           
       </select>
       </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaInicio">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaInicio">
      </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaFin">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaFin">
      </div>
    </div>
    <button class="btn btn-sm btn-primary mt-3" @click="generarReporte()">Generar reporte</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Exportar Excel</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportCSV()">Exportar CSV</button>
    <div class="table-responsive mt-4">
      <table class="table table-bordered table-hover text-center">
        <thead style="background-color: #05123C;">
          <tr class="text-white">
            <th>Unidad</th>
            <th>Sucursal</th>
            <th>Evento</th>
            <th>Duracion</th>
            <!--<th>Frenado Brusco</th>-->
            <!--<th>Hora</th>-->
            <!--<th>Aceleracion Brusca</th>-->
            <!--<th>Latitud</th>
            <th>Longitud</th>-->
            <th>Direccion</th>
            <!--<th>Velocidad Proyectada</th>-->
            <!--<th>Velocidad Permitida</th>-->
            <th>Fecha</th>
            <!--<th>Ubicacion</th>-->
            <!-- <th>Horas motor</th> -->
            <!-- <th>Combustible utilizado</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item of formatearDatos">
            <td>{{ item.Unidad}}</td>
            <td>{{item.Comodin}}</td>           
            <td >{{ item.Evento}}</td>
            <td >{{ item.Duracion}}</td>
            <td>{{ item.Direccion}}</td>
            <td>{{ item.Fecha}}</td>
            <!--<td>{{ item.address}}</td>-->
            <!--<td>{{(item.deviceId).substr(-3)}}</td>-->
            <!--<td v-if="item.ExcesoVelocidad == 'Sin datos'"></td>
            <td v-else>{{ item.ExcesoVelocidad }}</td>-->
            <!--<td >{{ item.ExcesoVelocidad }}</td>-->
            <!--<td v-if="item.FrenadoBrusco == 2">Frenado Brusco</td>
            <td v-else></td>-->
             <!--<td>{{ item.FrenadoBrusco}}</td>
            <td v-if="item.AceleracionBrusca == 1">Aceleracion Brusca</td>
            <td v-else></td>-->
           <!-- <td>{{item.deviceTime}}</td>-->
            <!--<td>99</td>
            <td>70</td>
            <td>1:20</td>-->
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>

import { mapState, mapMutations, mapActions } from "vuex";
//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
  data() {
    return {
      combinados:[],
      dispositivosObtenidos: [],
      dispositivosSeleccionados: [],
      dispositivosSeleccionados2: [],
      gruposObtenidos: [],
      posiciones:[],
      eventos:'',
      gruposSeleccionados: [],
      gruposSeleccionados2: [],
      geocercasObtenidas: [],
      fechaInicio: '',
      horaInicio: '00:00',
      fechaFin: '',
      horaFin: '00:00',
      datosReporte: [],
      datosReporte2: []
    }
  },
  watch: {
    dispositivosSeleccionados(newSelected) {
  
     
      this.dispositivosSeleccionados = newSelected;
      
    },
    gruposSeleccionados(newSelected) {
  
     
  this.gruposSeleccionados = newSelected;

}
  },


  computed: {
    ...mapState({
      catUnidades: state => state.catalogos.catUnidades
    }),

    ...mapState(["cargando"]),

    formatearIds() {
      //let data = '';
      var index = 0;
      this.dispositivosSeleccionados2 = [];
      for (let item of this.dispositivosSeleccionados) {
        //(index == 0) ? data += 'deviceId=' + item.id : data += '&deviceId=' + item.id;
        this.dispositivosSeleccionados2.push(item.id);
        index++;
      }
      return this.dispositivosSeleccionados2;
    },
    
    formatearPosition() {
      let data = '';
           var index = 0;
          for (let item of this.datosReporte) {
          (index == 0) ? data += 'id=' + item.positionId : data += '&id=' + item.positionId;
           index++;
           }
      return data;
    },

    formatearIdGrupo() {
       var index = 0;
       this.gruposSeleccionados2= [];
      for (let item of this.gruposSeleccionados) {
        this.gruposSeleccionados2.push(item.id);
        index++;
      }
      return this.gruposSeleccionados2;
    },

    formatearDatos() {
      var index = 0;
      
     
      for (var item of this.datosReporte) {
        //item.Unidad = (item.distance/1000).toFixed(2);
        item.Comodin = (item.Unidad).substr(-3);
        
        if(item.Duracion > 0 & item.Duracion != ' ')
        {
        item.Duracion = item.Duracion + ' ' + 'Seg';
        }
        else
        {
            ' ';
        }
      
        if (item.Valor > 0)
        {
            item.Evento = item.Evento +  ' ' + (item.Valor*1.852).toFixed(1)+  ' '+ 'km/h' ;
        }
        else
        {
            item.evento;
        }
        index++;
      }
      return this.datosReporte;
    }


  },

 
  methods: {
    ...mapActions("catalogos", ["obtenerUnidades"]),
    ...mapMutations(["setearCargando"]),

    obtenerSesion() {
      let params = new URLSearchParams();
      params.append("email", "desarrollo.gps@busmen.com");
      params.append("password", "12345");
      let headers = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

      axios.post(`${url}session`, params, JSON.parse(localStorage.user))
        .then(response => {
          console.log("Sesion");
        })
        .catch(error => {
          console.log("No sesion");
        });
    },

    generarReporte() {
      if (this.fechaInicio !='' & this.fechaFin.length !='' & this.gruposSeleccionados.length !='' || this.dispositivosSeleccionados.length!='' & this.fechaInicio !='' & this.fechaFin.length !='') {
        let fechaInicio = encodeURIComponent( new Date(this.fechaInicio + ' ' + this.horaInicio).toISOString().split('.')[0]+"Z" );
        let fechaFin = encodeURIComponent( new Date(this.fechaFin + ' ' + this.horaFin).toISOString().split('.')[0]+"Z" );

        this.setearCargando(true);
        //this.reporteTelemetrias(fechaInicio, fechaFin);
        if (this.eventos == 'deviceOverspeed') {
          this.reporteTelemetrias(fechaInicio, fechaFin);
        }else if (this.eventos == 1){
          this.reporteGrupos(fechaInicio, fechaFin);
        }
        else if (this.eventos == 'Velocity'){
          this.reporteCompletoVelocity(fechaInicio, fechaFin);
        }
        else{
          this.reporteCompleto(fechaInicio, fechaFin);
        }
      }
      else if(this.gruposSeleccionados == '' & this.dispositivosSeleccionados == '' & this.fechaInicio == '' & this.fechaFin.length == ''){
        alert('Debe seleccionar las fechas y unidades o grupos');
      }
      else if(this.gruposSeleccionados != '' || this.dispositivosSeleccionados != ''){
        alert("Debe seleccionar las fechas");
      }
      else if(this.fechaInicio != '' & this.fechaFin.length != ''){
        alert("Debe seleccionar las Unidades o Grupos");
      }
     
      
    },

    reporteDispositivos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIds}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },

    /*reporteGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/events?${this.formatearIdGrupo}&type=deviceOverspeed&from=${fechaInicio}&to=${fechaFin}` , headers)
        .then(response => {
          this.datosReporte = response.data;
           axios.get(`${url}positions?${this.formatearPosition}` , headers)
        .then(response => {
          this.datosReporte2 = response.data;         
          this.setearCargando(false);
        }) 
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },*/
    
    reporteGrupos(fechaInicio, fechaFin){
      axios.post(`${url2}eventostelemetriaacelefrena`,{
        'deviceid' : this.formatearIds,'groupid' : this.formatearIdGrupo,'FechaInicio' : this.fechaInicio + ' ' + this.horaInicio, 'FechaFin' : this.fechaFin + ' ' + this.horaFin }, {
        headers: {'content-type' : 'application/json'}})
      .then(response => {
          this.datosReporte = response.data.datos;
         // this.removeAll();
          //console.log(this.datosReporte)
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },
    
    async reporteCompleto(fechaInicio, fechaFin) {
  try {
    this.combinados = [];

    // First Axios request
    const response1 = await axios.post(`${url2}eventostelemetriavelocity`, {
      'deviceid': this.formatearIds,
      'groupid': this.formatearIdGrupo,
      'FechaInicio': this.fechaInicio + ' ' + this.horaInicio,
      'FechaFin': this.fechaFin + ' ' + this.horaFin
    }, {
      headers: { 'content-type': 'application/json' }
    });

    this.combinados = response1.data.datos;
    console.log('1');

    // Second Axios request
    const response2 = await axios.post(`${url2}eventostelemetriaacelefrena`, {
      'deviceid': this.formatearIds,
      'tipoEvento': this.eventos,
      'groupid': this.formatearIdGrupo,
      'FechaInicio': this.fechaInicio + ' ' + this.horaInicio,
      'FechaFin': this.fechaFin + ' ' + this.horaFin
    }, {
      headers: { 'content-type': 'application/json' }
    });

    this.datosReporte = this.combinados.concat(response2.data.datos);
    console.log('2');
    this.setearCargando(false);

  } catch (error) {
    alert('Ha ocurrido un error');
    this.setearCargando(false);
  }
},
    reporteCompletoVelocity(fechaInicio, fechaFin){
      axios.post(`${url2}eventostelemetriavelocity`,{
        'deviceid' : this.formatearIds,'groupid' : this.formatearIdGrupo,'FechaInicio' : this.fechaInicio + ' ' + this.horaInicio, 'FechaFin' : this.fechaFin + ' ' + this.horaFin }, {
        headers: {'content-type' : 'application/json'}})
      .then(response => {
          this.datosReporte = response.data.datos;
        // this.removeAll();
          //console.log(this.datosReporte)
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },
    reporteTelemetrias(fechaInicio, fechaFin){
      axios.post(`${url2}eventostelemetriaacelefrena`,{
        'deviceid' : this.formatearIds,'tipoEvento' : this.eventos,'groupid' : this.formatearIdGrupo,'FechaInicio' : this.fechaInicio + ' ' + this.horaInicio, 'FechaFin' : this.fechaFin + ' ' + this.horaFin }, {
        headers: {'content-type' : 'application/json'}})
      .then(response => {
          this.datosReporte = response.data.datos;
        //  this.removeAll();
          //console.log(this.datosReporte)
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },
    
    /*reporteTelemetrias(fechaInicio, fechaFin){
     axios.get(`${url}reports/events?${this.formatearIds}&type=deviceOverspeed&from=${fechaInicio}&to=${fechaFin}` , headers)
        .then(response => {
          this.datosReporte = response.data;*/
         
          /*var uniqs = this.posiciones.filter(function(item, index, array) {
          return array.indexOf(item) === index;
             })*/
          //console.log(uniqs);
         /* axios.get(`${url}positions?${this.formatearPosition}` , headers)
        .then(response => {
          this.datosReporte2 = response.data;         
          this.setearCargando(false);
        }) 
          this.setearCargando(false);
        })
      
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },*/
    
    selectAll() {
      this.dispositivosSeleccionados = [];
      for (let item of this.dispositivosObtenidos) {
          this.dispositivosSeleccionados.push(item);
      }
    },
     selectAllGrupos() {
      this.gruposSeleccionados = [];
      for (let item of this.gruposObtenidos) {
          this.gruposSeleccionados.push(item);
      }
    },

    removeAll() {
      this.dispositivosSeleccionados = [];
      this.dispositivosSeleccionados2 = [];
      this.gruposSeleccionados = [];
      this.gruposSeleccionados2 = [];
    },
    
    removeAllGrupos() {
      this.gruposSeleccionados = [];
    },

    exportExcel() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte, { header: ['Unidad', 'Comodin','Evento','Duracion','Direccion','Fecha'] } );
        data['A1'].v = 'Unidad';
        data['B1'].v = 'Sucursal';
        data['C1'].v = 'Evento';
        data['D1'].v = 'Duracion';
        data['E1'].v = 'Direccion';
        data['F1'].v = 'Fecha';
        //data['F1'].v = 'Fecha';
        //data['G1'].v = 'Longitud';
        //data['H1'].v = 'Fecha';

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
      //  XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },
    exportCSV() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte, { header: ['Unidad', 'Comodin','Evento','Duracion','Direccion','Fecha'] } );
        data['A1'].v = 'Unidad';
        data['B1'].v = 'Sucursal';
        data['C1'].v = 'Evento';
        data['D1'].v = 'Duracion';
        data['E1'].v = 'Direccion';
        data['F1'].v = 'Fecha';
        //data['F1'].v = 'Fecha';
        //data['G1'].v = 'Longitud';
        //data['H1'].v = 'Fecha';

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
       // XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },

    obtenerDispositivos() {
      this.setearCargando(true);
      axios.get(`${url}devices`, JSON.parse(localStorage.user))
        .then(response => {
          this.dispositivosObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

    obtenerGrupos() {
      this.setearCargando(true);
      axios.get(`${url}groups`, JSON.parse(localStorage.user))
        .then(response => {
          this.gruposObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
    
     obtenerGeocercas() {
      this.setearCargando(true);
      axios.get(`${url}geofences`, JSON.parse(localStorage.user))
        .then(response => {
          this.geocercasObtenidas = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
  },

  created() {
    this.obtenerDispositivos();
    this.obtenerGrupos();
    this.obtenerGeocercas();
    // this.obtenerUnidades();
    // this.obtenerSesion();
  },

  mounted() {
    // this.obtenerKilometraje();
    if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
  }
  }
}
</script>
<style>
  .telemetria{
    margin: 50px;
    margin-bottom:1%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-top:15px;
  }
</style>